import styles from "./styles.module.scss";
import { useContext} from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import { TranslationContext } from "../../../../../../contexts/translation/index.context";
//Components
import Drawer from "../../../../../ui/drawer";
import Directories from "../../../../../directories";
//UI
import Form from "antd/lib/form";
import Input from "antd/lib/input";
//Icons
import KeyOutlined from "@ant-design/icons/KeyOutlined";
//Locale
import "dayjs/locale/uk";

dayjs.extend(customParseFormat);
dayjs.locale("uk");


export function MenuTabs({ pathname }: { pathname: string }) {
  const { intl } = useContext(TranslationContext);

  return (
    <Form.Item
      label={intl("menu-tab-name")}
      name="nameFolder"
      rules={[
        {
          required: true,
          message: intl("name-folder-required"),
        },
      ]}
    >
      <Input />
    </Form.Item>
  );
}
